import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const PatientAcquisition = () => {
  const relatedBlogs = [
    {
      id: 1,
      title: 'How to Optimize Your Medical Practice Website for Local SEO in 2026',
      image: '/images/Blog4.png',
      date: 'February 3, 2026'
    },
    {
      id: 5,
      title: 'The Complete Guide to Google Ads for Healthcare Providers',
      image: '/images/Blog6.png',
      date: 'January 20, 2026'
    },
    {
      id: 8,
      title: 'Converting Website Visitors into Booked Appointments: A Data-Driven Approach',
      image: '/images/Blog10.png',
      date: 'January 18, 2026'
    }
  ];

  return (
    <div className="font-['Raleway',sans-serif] bg-white text-gray-900 overflow-x-hidden pt-[90px]">
      
      <Navbar />

      {/* HERO SECTION */}
      <section className="relative min-h-[300px] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=1920&q=80')`,
          }}
        />
        <div className="absolute inset-0 bg-[#19354a]/90" />
        
        <div className="relative z-10 text-center px-4 sm:px-6">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 sm:mb-8"
          >
            Patient Acquisition Strategies
          </motion.h1>
          
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex items-center justify-center gap-2 sm:gap-4 flex-wrap"
          >
            <Link 
              to="/" 
              className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all text-sm sm:text-base"
            >
              Home
            </Link>
            <span className="text-white text-xl sm:text-2xl">|</span>
            <Link 
              to="/blog" 
              className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all text-sm sm:text-base"
            >
              Blog
            </Link>
            <span className="text-white text-xl sm:text-2xl">|</span>
            <span className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold text-sm sm:text-base">
              Patient Acquisition
            </span>
          </motion.div>
        </div>
      </section>

      {/* SECTION 1: TWO-COLUMN WITH SIDEBAR */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          
          <div className="grid lg:grid-cols-12 gap-6 lg:gap-8">
            
            {/* LEFT SIDE - Intro Content */}
            <div className="lg:col-span-8">
              
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="mb-8"
              >
                <img 
                  src="/images/blog9.png" 
                  alt="Patient Acquisition"
                  className="w-full rounded-2xl"
                />
              </motion.div>

              <motion.h1
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#19354a] mb-6"
              >
                Patient Acquisition Strategies That Work in 2026
              </motion.h1>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="flex flex-wrap items-center gap-4 text-sm text-[#19354a] mb-8 pb-6 border-b-2 border-gray-200"
              >
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                  </svg>
                  <span>Docmize Team</span>
                </div>
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                  </svg>
                  <span>Published : February 1, 2026</span>
                </div>
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                  </svg>
                  <span>Last Updated : February 1, 2026</span>
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
              >
                <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
                  Patient acquisition remains the lifeblood of medical practice growth, requiring strategic approaches that attract qualified patients while maintaining cost-effectiveness and professional standards. In 2026, successful medical practices combine digital marketing, patient experience optimization, and data-driven strategies to build sustainable patient pipelines that support long-term growth and profitability.
                </p>

                <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
                  This comprehensive guide explores proven patient acquisition strategies that help medical practices attract more patients consistently. From online booking optimization and referral programs to digital advertising and community engagement, learn how to implement acquisition systems that deliver measurable results and positive return on investment.
                </p>
              </motion.div>

            </div>

            {/* RIGHT SIDE - Sidebar */}
            <motion.aside 
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="lg:col-span-4"
            >
              <div className="sticky top-24">
                
                <div className="bg-white rounded-2xl border-2 border-[#19354a] p-6 mb-6">
                  <h3 className="text-xl font-bold text-[#19354a] mb-6 pb-4 border-b-2 border-gray-200">
                    Categories
                  </h3>
                  <div className="space-y-2">
                    {['Patient Acquisition', 'Digital Marketing', 'SEO', 'Social Media', 'Healthcare Technology', 'Content Marketing', 'Web Development', 'Online Reputation Management'].map((category, index) => (
                      <Link
                        key={index}
                        to="/blog"
                        className="w-full text-left px-4 py-3 rounded-lg font-medium transition-all bg-gray-50 text-gray-700 hover:bg-[#19354a] hover:text-white block"
                      >
                        <div className="flex items-center justify-between">
                          <span>{category}</span>
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                          </svg>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>

                <div className="bg-gradient-to-br from-[#19354a] to-[#0f2133] rounded-2xl p-6 text-white">
                  <h3 className="text-xl font-bold mb-4">
                    Need Help Acquiring Patients?
                  </h3>
                  <p className="text-white/80 mb-6 text-sm leading-relaxed">
                    Get expert patient acquisition strategies tailored to your practice.
                  </p>
                  <Link 
                    to="/contact"
                    className="block w-full text-center px-6 py-3 bg-[#39a5d3] text-white rounded-lg font-semibold hover:bg-white hover:text-[#19354a] transition-all"
                  >
                    Get Free Consultation
                  </Link>
                </div>

              </div>
            </motion.aside>

          </div>
        </div>
      </section>

      {/* SECTION 2: FULL WIDTH CONTENT */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Understanding Modern Patient Acquisition
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Patient acquisition in 2026 requires integrated strategies combining digital marketing, patient experience, and relationship building. Modern patients research extensively before choosing healthcare providers, comparing online reviews, website quality, service offerings, and accessibility factors. Successful practices create seamless patient journeys from initial awareness through appointment booking and first visit experiences.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Effective patient acquisition focuses on attracting qualified patients who match your practice specialty and values. Rather than simply maximizing patient volume, strategic acquisition targets ideal patients likely to become long-term relationships, generating sustainable revenue through ongoing care and referrals. Quality always trumps quantity in healthcare patient acquisition.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Optimizing Online Booking Systems
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Online appointment booking has become essential for patient acquisition, with 70% of patients preferring digital scheduling options. Implement user-friendly booking systems prominently displayed on your website, accessible from mobile devices, and integrated with your practice management software. Reduce friction by minimizing required information, offering flexible appointment options, and providing instant confirmation.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Enable 24/7 booking availability, allowing patients to schedule appointments outside business hours when they're researching healthcare options. Offer new patient appointment options, clearly communicate what to expect during first visits, and send automated confirmation and reminder messages. Streamlined booking processes significantly increase conversion rates from website visitors to booked appointments.
            </p>

            <h3 className="text-xl sm:text-2xl font-bold text-[#19354a] mb-4 mt-6">
              Booking System Best Practices
            </h3>

            <ul className="list-disc list-inside text-gray-900 text-base leading-relaxed mb-6 space-y-2 ml-4 text-justify">
              <li>Mobile-responsive booking interface with simple navigation</li>
              <li>Minimal required information to reduce abandonment</li>
              <li>Clear provider profiles with specialties and credentials</li>
              <li>Real-time availability display and instant confirmation</li>
              <li>New patient intake forms completed before appointments</li>
              <li>Automated confirmation, reminder, and follow-up messages</li>
            </ul>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Building Referral Programs That Work
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Patient referrals generate highly qualified new patients at minimal acquisition cost. Develop systematic referral programs encouraging satisfied patients to recommend your practice. Create easy referral processes, provide referral cards or digital sharing options, and express appreciation for referrals. Consider referral incentives like discounted services, wellness products, or charitable donations.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Build professional referral networks with complementary healthcare providers, specialists, and allied health professionals. Establish mutual referral relationships providing value to referring providers and their patients. Maintain regular communication with referral sources, provide excellent patient care that reflects positively on referring providers, and reciprocate referrals when appropriate.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Leveraging Digital Advertising
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Strategic digital advertising accelerates patient acquisition by targeting ideal patient demographics searching for healthcare services. Implement Google Ads campaigns targeting relevant medical keywords, geographic areas, and patient demographics. Use compelling ad copy highlighting unique value propositions, convenient locations, appointment availability, and patient benefits.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Supplement search advertising with social media campaigns on Facebook, Instagram, and LinkedIn. Target specific demographics, interests, and behaviors matching your ideal patient profiles. Create engaging ad creative showcasing practice differentiators, patient testimonials, educational content, and clear calls-to-action. Monitor ad performance closely, optimize based on results, and maintain compliance with healthcare advertising regulations.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Creating Exceptional First Impressions
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              First visit experiences significantly impact patient retention and referral generation. Optimize every touchpoint from initial phone contact through post-appointment follow-up. Train staff in patient-centered communication, reduce wait times, create comfortable environments, and ensure smooth check-in processes. First impressions set the tone for entire patient relationships.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Welcome new patients warmly, explain processes clearly, address questions thoroughly, and exceed expectations with personalized care. Follow up after initial visits to ensure satisfaction, address concerns, and schedule future appointments. New patients who receive exceptional first experiences become long-term patients and enthusiastic referral sources.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Community Engagement Strategies
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Active community involvement builds practice awareness, establishes expertise, and generates patient acquisition opportunities. Participate in health fairs, sponsor community events, offer free health screenings, conduct educational seminars, and partner with local organizations. Community engagement positions your practice as a trusted healthcare resource while creating natural referral pathways.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Develop relationships with community organizations, schools, businesses, and civic groups. Offer workplace wellness programs, corporate health initiatives, and educational presentations. Community visibility combined with reputation for quality care creates powerful word-of-mouth marketing that drives sustainable patient acquisition.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Measuring and Optimizing Acquisition Performance
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Track key patient acquisition metrics including cost per acquisition, conversion rates, patient lifetime value, referral sources, and marketing channel performance. Understand which strategies generate highest quality patients at optimal costs. Use data insights to optimize marketing spend, refine targeting, and improve conversion processes throughout the patient journey.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Implement attribution tracking to understand patient acquisition pathways. Analyze website analytics, call tracking data, appointment booking sources, and patient surveys. Continuously test and optimize acquisition strategies based on performance data. Successful patient acquisition requires ongoing measurement, analysis, and strategic refinement to maximize return on investment.
            </p>

            {/* FAQ SECTION */}
            <div className="mt-12 mb-12">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-8 text-center">
                Frequently Asked Questions (FAQs)
              </h2>

              <div className="space-y-4">
                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      What's the average cost per patient acquisition?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Average patient acquisition costs vary widely by specialty, location, and marketing channels, typically ranging from $200-$1000 per new patient. Focus on patient lifetime value rather than acquisition cost alone. High-value patients with long-term care needs justify higher acquisition investments.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      Which patient acquisition channel works best?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    The most effective channels vary by practice type, location, and target demographics. Generally, patient referrals generate highest quality patients, while local SEO and online reviews provide consistent leads. Most successful practices use integrated multi-channel strategies rather than relying on single channels.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      How long does it take to see results?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Digital advertising can generate immediate patient inquiries. SEO and content marketing typically require 3-6 months for significant results. Referral program development takes time but provides long-term sustainable growth. Comprehensive strategies combining multiple channels deliver best results over 6-12 month periods.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      Should we focus on new patients or retention?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Both are essential. Patient retention is typically more cost-effective than acquisition, but new patient acquisition drives practice growth. Successful practices balance acquisition and retention strategies, ensuring excellent patient experiences that convert new patients into long-term relationships and referral sources.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      How can Docmize help with patient acquisition?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Docmize specializes in comprehensive patient acquisition strategies for medical practices. We handle digital marketing, website optimization, online booking implementation, advertising campaigns, referral program development, and performance tracking. Our healthcare expertise ensures compliant, effective strategies that deliver measurable patient growth.
                  </div>
                </details>
              </div>
            </div>

          </motion.div>
        </div>
      </section>

      {/* RELATED BLOGS SECTION */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-3xl sm:text-4xl font-bold text-[#19354a] mb-8"
          >
            Related Blog
          </motion.h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {relatedBlogs.map((blog, index) => (
              <motion.article
                key={blog.id}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white rounded-xl overflow-hidden hover:shadow-xl transition-all duration-300"
              >
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={blog.image} 
                    alt={blog.title}
                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-bold text-[#19354a] mb-3 line-clamp-2">
                    {blog.title}
                  </h3>
                  <div className="flex items-center gap-2 text-sm text-gray-500 mb-4">
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                    </svg>
                    <span>{blog.date}</span>
                  </div>
                  <Link 
                    to="/blog"
                    className="inline-flex items-center gap-2 text-[#39a5d3] font-semibold hover:gap-3 transition-all"
                  >
                    Read More
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </Link>
                </div>
              </motion.article>
            ))}
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PatientAcquisition;